var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNewOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 14C10.8634 14 14 10.8634 14 7C14 3.13659 10.8634 0 7 0C3.13659 0 0 3.13659 0 7C0 10.8634 3.13659 14 7 14ZM6.34375 9.40625V7.65625H4.59375C4.23008 7.65625 3.9375 7.36367 3.9375 7Cnan nan 4.23008 6.34375 4.59375 6.34375H6.34375V4.59375C6.34375 4.23008 6.63633 3.9375 7 3.9375Cnan nan 7.65625 4.23008 7.65625 4.59375V6.34375H9.40625C9.76992 6.34375 10.0625 6.63633 10.0625 7Cnan nan 9.76992 7.65625 9.40625 7.65625H7.65625V9.40625C7.65625 9.76992 7.36367 10.0625 7 10.0625Cnan nan 6.34375 9.76992 6.34375 9.40625Z",
    fill: "#FF5722"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNewOrange);
export default __webpack_public_path__ + "static/media/ic_new_orange.5aa8e53923b1d23deef73e9ed4557bc5.svg";
export { ForwardRef as ReactComponent };